interface Params {
  currentPage: number;
  filteredRowCount: number;
  filterChanged: boolean;
  hasFilter: boolean;
  pageSize: number;
  rowsAdded: boolean;
  totalRowCount: number;
}

export function getNextTaggedHotelPage({
  currentPage,
  filteredRowCount,
  filterChanged,
  hasFilter,
  pageSize,
  rowsAdded,
  totalRowCount,
}: Params): number {
  const currentPageStart = currentPage * pageSize;

  if (filterChanged || (currentPage > 0 && currentPageStart >= filteredRowCount)) {
    return 0;
  }

  if (!hasFilter && rowsAdded) {
    return Math.max(0, Math.ceil(totalRowCount / pageSize) - 1);
  }

  return currentPage;
}
